export const onDone = creds => ({
  widget: 'login',
  type: 'onDone',
  payload: { creds },
})



// WEBPACK FOOTER //
// ./src/login/actions/onDone.js